module.exports = __webpack_public_path__ + "img/sphere07-graph-black.a610a633.png";